<div [class]="hostClass$()">
  @if (hasIcon$()) {
    <!-- Mood owns the icon choice and badge color, so consumers choose intent rather than artwork. -->
    <lab-icon class="lab-notification__icon" [name]="icon$()" [mood]="iconMood$()" shape="circle-outline" size="24" />
  }

  @if (hasContent$()) {
    <div class="lab-notification__content">
      @if (hasHeading$()) {
        <div class="lab-notification__heading">{{ heading$() | translate }}</div>
      }
      @if (hasDescription$()) {
        <div class="lab-notification__description">{{ description$() | translate }}</div>
      }
    </div>
  }

  @if (hasControls$()) {
    <!-- Action and dismiss share one control group, so spacing only exists when right-side controls exist. -->
    <div class="lab-notification__controls">
      <!-- Actions use the shared LabAction shape, so feedback surfaces do not
           invent one-off action label props. -->
      @if (secondaryAction$(); as action) {
        <lab-button
          [variant]="action.variant ?? SolButtonType.transparent"
          [mood]="action.mood ?? 'default'"
          [text]="action.text"
          [icon]="action.icon"
          [appendIcon]="action.appendIcon"
          [disabled]="action.disabled ?? false"
          [loading]="action.loading ?? false"
          [ariaLabel]="action.ariaLabel"
          (click)="onSecondaryAction(action)"
        />
      }

      @if (action$(); as action) {
        <!-- Primary action chrome follows the toast mood unless the action
             explicitly asks for a different mood. -->
        <lab-button
          [variant]="action.variant ?? SolButtonType.primary"
          [mood]="action.mood ?? actionButtonMood$()"
          [text]="action.text"
          [icon]="action.icon"
          [appendIcon]="action.appendIcon"
          [disabled]="action.disabled ?? false"
          [loading]="action.loading ?? false"
          [ariaLabel]="action.ariaLabel"
          (click)="onAction(action)"
        />
      }

      @if (dismissible$()) {
        <lab-button
          [variant]="SolButtonType.transparent"
          [icon]="dismissIcon"
          [ariaLabel]="dismissLabel"
          (click)="onDismiss()"
        />
      }
    </div>
  }

  @if (timed$()) {
    <!-- Timed notifications get a quiet lifetime hint; the host/service still owns actual removal. -->
    <div class="lab-notification__timer" aria-hidden="true"></div>
  }
</div>
